const LANE_STOPS = ['pickup', 'delivery']

const DEFAULT_SEPARATORS = {
  fragment: ':',
  stop: ';',
  lane: '|',
}

function toLaneStop(stop, radius, separators) {
  const parts = [stop.lat, stop.lng, radius || '']

  if (stop.description) {
    parts.unshift(stop.description)
  }

  return parts.join(separators.fragment)
}

function toLaneFragment(lane, separators) {
  return `${LANE_STOPS.map(someStop =>
    lane[someStop] && lane[someStop].lat && lane[someStop].lng
      ? toLaneStop(lane[someStop], lane.radius, separators)
      : ''
  ).join(separators.stop)}`
}

function toLanesQueryString(lanes, givenSeparators) {
  const separators = {
    ...DEFAULT_SEPARATORS,
    ...(givenSeparators || {}),
  }

  return lanes.map(someLane => toLaneFragment(someLane, separators)).join(separators.lane) || null
}

export { toLanesQueryString }
